module.exports = __webpack_public_path__ + "static/media/arrow-b.ad016142.svg";